module.exports = __webpack_public_path__ + "img/word.0551a256.jpg";